import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import { store } from "./srcWeb/store";
import { buildSentryInitOptions } from "./sentry/sentryInitOptions";
import { initializeMixpanel } from "./mixpanel";
import config from "./config/environment";

Sentry.init(buildSentryInitOptions(config));

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.COGNITO_USERPOOL_ID || "",
      userPoolClientId: process.env.COGNITO_CLIENT_ID || "",
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: "code",
      userAttributes: {
        email: {
          required: true,
        },
      },
    },
  },
});

initializeMixpanel();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
